import { useRef, useState, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import {
  DataTable,
  GridButton,
  PageHeader,
  InputTypeConstants,
  SearchParamTypeConstants,
  getSearchField,
  getTableHeader,
} from "wup-module1-base";
import { PageTitleConstants, RoutePathConstants } from "../../../Constants";
import { useNavigate, useParams } from "react-router-dom";
import {
  faPencil,
  faCircleCheck,
  faCircleXmark,
  faMagnifyingGlass,
  faTrash,
  faObjectGroup,
  faUsersBetweenLines,
  faComments,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PageList() {
  const navigate = useNavigate();
  const pagesRef = useRef();
  const { questionnaireId } = useParams();
  const [questionnaireName, setQuestionnaireName] = useState(null);

  useEffect(() => {
    if (!!questionnaireId) {
      setQuestionnaireName(
        JSON.parse(sessionStorage.getItem("questionnaires"))?.find(
          (i) => i.id === questionnaireId
        )?.name
      );
    }
  }, [questionnaireId]);

  function getActionButtons(value) {
    return (
      <>
        <GridButton
          id={"btnPreview" + value.id}
          color="btn-success"
          icon={faList}
          disabled={false}
          ariaLabel="Lista pytań"
          title="Lista pytań"
          onClick={() => navigate(`${value.id}`)}
        />
        <GridButton
          id={"btnEdit" + value.id}
          color="btn-primary"
          icon={faPencil}
          disabled={value.deleted}
          ariaLabel="Edycja strony"
          title="Edycja strony"
          onClick={() =>
            navigate(
              `/${RoutePathConstants.Page}/${RoutePathConstants.Edit}/${value.id}`
            )
          }
        />
      </>
    );
  }

  function fetchPages() {
    return JSON.parse(sessionStorage.getItem("pages"))?.filter(
      (i) => i.questionnaireId === questionnaireId
    );
  }

  const renderEmpty = (value) => {
    let flag = false;
    const questions = JSON.parse(sessionStorage.getItem("questions"));
    if (!!questions) flag = questions.some((q) => q.pageId === value.id);
    return flag ? (
      <FontAwesomeIcon
        icon={faCircleCheck}
        title="Tak"
        className="text-success"
        size="xl"
      />
    ) : (
      <FontAwesomeIcon
        icon={faCircleXmark}
        className="text-danger"
        title="Nie"
        size="xl"
      />
    );
  };

  const searchFields = [
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "name",
      "Nazwa",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "description",
      "Opis",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_EQUAL,
      "deleted",
      "Pokaż usunięte",
      InputTypeConstants.checkbox
    ),
  ];

  const tableHeaders = [
    getTableHeader("Nazwa", "name", null, true, "w-15"),
    getTableHeader("Opis", "description", null, true, "w-auto"),
    getTableHeader(
      "Czy zawiera pytania",
      null,
      null,
      false,
      "w-15",
      renderEmpty,
      "text-center"
    ),
    getTableHeader(
      null,
      null,
      "Akcje",
      false,
      "w-10",
      getActionButtons,
      "text-center"
    ),
  ];

  const getRowProps = (value) => ({
    className: value.deleted ? "row-deleted" : "",
  });

  return (
    <>
      <PageHeader
        content={PageTitleConstants.PageList}
        additionalContent={questionnaireName ?? null}
      />
      <Card>
        <Card.Body className="pt-4-5">
          <DataTable
            fetchData={fetchPages}
            headers={tableHeaders}
            searchFields={searchFields}
            rowProps={getRowProps}
            ref={pagesRef}
          >
            {/* <Button
              variant="primary"
              onClick={() => navigate(`${RoutePathConstants.Add}`)}
            >
              Dodaj stronę
            </Button> */}
          </DataTable>
        </Card.Body>
      </Card>
    </>
  );
}

export default PageList;
